import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { SuitSymbols, SuitColors } from './BridgeTypes';
import './BridgeMarkdown.css';

interface BridgeMarkdownProps {
    className?: string;
    children: string;
}

const BridgeMarkdown: React.FC<BridgeMarkdownProps> = ({ children, className }) => {
    let markdown = children;

    // insert span with correct color for suits.
    SuitSymbols.forEach((suit, index) => {
        const suitSymbol = SuitSymbols[index];
        const suitColor = SuitColors[index];
        if (suitColor !== 'black') {
            const suitSpan = `<span style="color: ${suitColor};">${suitSymbol}</span>`;
            markdown = markdown.replace(new RegExp(suitSymbol, 'g'), suitSpan);
        }
    });

    // look for a digit followed by 'NT' and replace 'NT' reduced 80%.
    markdown = markdown.replace(/(\d)(nt)/gi, (match, p1, p2) => {
        return `${p1}<span style="font-size: 75%;">NT</span>`;
    });

    //TODO: add links to wikipedea for bridge terms.

    return (
        <ReactMarkdown className={`markdown-body ${className || ''}`} rehypePlugins={[rehypeRaw]}>
            {markdown}
        </ReactMarkdown>
    )
    // for testing to see the original text.
    // return (
    //     <div>{text}</div>
    // )
};

export default BridgeMarkdown;